import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

export const APP_ID_SAMPLE = 'backoffice_sample_app';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  getTitle(): string {
    let result = 'H+ Backoffice SampleApp';
    if (!environment.production) {
      result += ' (dev)';
    }
    return result;
  }
}
